import styled from '@emotion/styled';

export const PageTitle = styled.h2`
  color: #fff;
  /* color: #0f4f6d; */
  font-weight: bold;
  text-transform: uppercase;
  white-space: nowrap;
  height: max-content;
  width: max-content;
`;
